/* eslint-disable no-shadow */

import React from 'react';
import { Menu, Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { logout } from '../../actions';

const TopBar = withRouter(({ openDrawer }) => (
  <Menu
    mode="horizontal"
    theme="dark"
    style={{ lineHeight: '50px' }}
    className='only-mobile'
  >
    {/* <Menu.Item key="logo" style={{ borderBottom: 0 }}>
        <img alt='iuh-logo' src="/assets/images/iuh-logo.png" style={{ height: '40px', width: 'auto', objectFit: 'contain' }} />
      </Menu.Item> */}
    <Menu.Item onClick={openDrawer} key="open-menu" style={{ borderBottom: 0 }}>
      <Icon style={{ marginRight: 0 }} type="menu-unfold" />
    </Menu.Item>
  </Menu>
));

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/components/layouts/MenuMobile.js